import Hls from "hls.js";

// this allows us to check in the worker that the client ran this piece of code.
// Low effort way to stop download via youtube-dl or "video download" extensions which just grab the hls playlist and download the referenced chunks.

const playerSignatureSharedKeyNotASecret = "notasecret";

//very simple hash of the path of the video chunk that we can later verify. custom thing becuse it's synchronous and less complicated than browser crypto.
function playerSignature(path) {
  let h = 0x9e3779b9;
  const s = playerSignatureSharedKeyNotASecret + path;
  for (let i = 0; i < s.length; i++) {
    h ^= s.charCodeAt(i);
    h = Math.imul(h, 0x9e3779b9);
    h ^= h >>> 16;
  }
  return (h >>> 0).toString(36);
}

export class playerSignatureFragLoader extends Hls.DefaultConfig.loader {
  constructor(config) { super(config); }
  load(context, config, callbacks) {
    const u = new URL(context.url);
    u.searchParams.set("s", playerSignature(u.pathname.slice(1))); //short for "player signature", this makes it a bit harder to search through the minifed JS code and find out it is generated.
    context = { ...context, url: u.toString() };
    super.load(context, config, callbacks);
  }
}
